/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum CreateOrganizationActions {
  OPEN_CREATE_ORGANIZATION_OVERLAY = 'OPEN_CREATE_ORGANIZATION_OVERLAY',
  CLOSE_CREATE_ORGANIZATION_OVERLAY = 'CLOSE_CREATE_ORGANIZATION_OVERLAY',
}

export type CreateOrganizationState = {
  isOpen: boolean;
};

export type OpenCreateOrganizationOverlayAction = {
  type: CreateOrganizationActions.OPEN_CREATE_ORGANIZATION_OVERLAY;
};

export type CloseCreateOrganizationOverlayAction = {
  type: CreateOrganizationActions.CLOSE_CREATE_ORGANIZATION_OVERLAY;
};

export type CreateOrganizationActionTypes = OpenCreateOrganizationOverlayAction | CloseCreateOrganizationOverlayAction;
